import {connect} from 'react-redux';
import TopBar from './TopBar';
import {selectIsDrawerOpen} from "state/app/selectors";
import {toggleDrawer} from "state/app/actions";

const mapStateToProps = state => ({
  drawerOpen: selectIsDrawerOpen(state),
});

const mapDispatchToProps = dispatch => ({
  toggleDrawer: () => dispatch(toggleDrawer())
});

export default connect(mapStateToProps,mapDispatchToProps)(TopBar);
